export default __webpack_public_path__ + "static/media/New.90731901.svg";